// Navbar.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './auth.js';


const Navbar = () => {
    const { user, logout } = useAuth();

    const getInitial = name => name.charAt(0).toUpperCase();
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">MySite</Link>

        <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarNav" aria-controls="navbarNav"
                aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/product">Our Products</Link>
              </li>
            <li className="nav-item">
            {user ? (
                <Link to="/my-content" className="nav-link">My Content</Link>
                    ) : (
                <button onClick={() => alert('Please login to add content')} className="nav-link">Add Content</button>
                    )}
            </li>
            {/* <li className="nav-item">
              <Link className="nav-link" to="/login">LogIn</Link>
            </li> */}
            {!user && (
            <>
              <li className="nav-item">
                <Link className="nav-link" to="/signup">Sign Up</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/login">Login</Link>
              </li>
            </>
          )}
          {user && (
            <li className="nav-item dropdown">
              <span className="nav-link dropdown-toggle d-flex align-items-center" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <div className="rounded-circle bg-primary text-white text-center me-2" style={{ width: 35, height: 35, lineHeight: '35px' }}>
                  {getInitial(user.username)}
                </div>
              </span>
              <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                <li><Link className="dropdown-item" to="/profile">Profile</Link></li>
                <li><button className="dropdown-item" onClick={logout} to="/">Logout</button></li>
              </ul>
            </li>
          )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
